import { useEffect, useState } from "react";
import NavBar from "../../components/organisms/navbar";
import {
  Container,
  Content,
  InfoContainerStatus,
  InfoContainerText,
  PageLocationTitle,
  PageTitle,
  PageTitleContainer,
  StatusButton,
  SubscriptionContainer,
  SubscriptionContent,
  SubscriptionDescription,
  SubscriptionItem,
  SubscriptionList,
  SubscriptionTitle,
} from "../profile/subscriptions/styles";
import api from "../../services/api";
import { toast } from "react-toastify";
import useAuthenticate from "../../hooks/useAuthenticate";
import Loading from "../../components/atoms/loading";
import React from "react";

import { useParams } from "react-router-dom";
import { StringToSlug, StringToSlugPraia } from "../../utils/SlugConverter";
import AllCheckCategoriesSeletivaManausOlimpica2024 from "./tournament/all-check-category-seletiva-manaus-olimpica-2024";
import AllCheckCategoriesCheckViiiReiERainhaDaPraiaBeachWrestiling2024 from "./tournament/all-check-category-viii-rei-e-rainha-da-praia-beach-wrestiling-manaus-amazonas-2024";
import AllCheckCategoriesCopaAmizadeDeJiuJitsu2024 from "./tournament/all-check-category-copa-amizade-de-jiu-jitsu-2024";
import AllCheckCategoriesCopaMestreAcaiDeJiuJitsu2024 from "./tournament/all-check-category-copa-mestre-acai-de-jiu-jitsu-2024";
import AllCheckCategoriesXxxiiCopaOrleyLobatoDeJiuJitsu from "./tournament/all-check-category-xxxii-copa-orley-lobato-de-jiu-jitsu";
import AllCheckCategoriesIOrixicombatOpenJiuJitsu from "./tournament/all-check-category-i-orixicombat-open-jiu-jitsu";
import AllCheckCategoriesJiuJitsuLaranjaEVerdeJuntos from "./tournament/all-check-category-jiu-jitsu-laranja-e-verde-juntos";
import AllCheckCategoriesCopaLoboBravoCresolDeJiuJitsu from "./tournament/all-check-category-copa-lobo-bravo-cresol-de-jiu-jitsu";
import AllCheckCategoriesIvOpenTerraSantaDeJiuJitsu from "./tournament/all-check-category-iv-open-terra-santa-de-jiu-jitsu";
import AllCheckCategoriesOpenAmazonasTopTeamDeJiuJitsu from "./tournament/all-check-category-vii-open-amazonas-top-team-de-jiu-jitsu";
import AllCheckCategoriesCopaCianorteDeJiuJitsu from "./tournament/all-check-category-copa-cianorte-de-jiu-jitsu";
import AllCheckCategoriesViReiDaPraiaDeJiuJitsuNoGi from "./tournament/all-check-category-vi-rei-da-praia-de-jiu-jitsu-no-gi";
import AllCheckCategoriesIiCopaChampionsKidsDeJiuJitsu from "./tournament/all-check-category-ii-copa-champions-kids-de-jiu-jitsu";
import AllCheckCategoriesIiiOpenRochaEMoraesDeJiuJitsu from "./tournament/all-check-category-iii-open-rocha-e-moraes-de-jiu-jitsu";
import AllCheckCategoriesIOpenLaranjeirasDoSulDeJiuJitsu from "./tournament/all-check-category-i-open-laranjeira-do-sul-de-jiu-jitsu";
import AllCheckCategoriesEstadualGfTeamAmazonasDeJiuJitsu from "./tournament/all-check-category-estadual-gf-team-amazonas-jiu-jitsu";
import AllCheckCategoriesXxixCopaLuisNetoDeJiuJitsu from "./tournament/all-check-category-xxix-copa-luis-neto-jiu-jitsu";
import AllCheckCategoriesEtapaOriximinaXxxiiCopaOrleyLobatoDeJiuJitsu from "./tournament/all-check-category-etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu";
import AllCheckCategoriesCampeonatoParintinenseDeJiuJitsu from "./tournament/all-check-category-campeonato-parintinense-de-jiu-jitsu";
import AllCheckCategoriesXviiiCopaParanaDeJiuJitsu from "./tournament/all-check-category-xviii-copa-parana-de-jiu-jitsu";
import AllCheckCategoriesCopaInTheGuardDeJiuJitsu from "./tournament/all-check-category-copa-in-the-guard-de-jiu-jitsu";
import AllCheckCategoriesCopaAmizadeDeJiuJitsu2025 from "./tournament/all-check-category-copa-amizade-de-jiu-jitsu-2025";
import AllCheckCategoriesViiCopaCampeoesDeJiuJitsu2025 from "./tournament/all-check-category-vii-copa-campeoes-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaTorneioFacilDeJiuJitsu from "./tournament/all-check-category-copa-torneio-facil-de-jiu-jitsu";
import AllCheckCategoriesCopaMercosulDeJiuJitsu2025 from "./tournament/all-check-category-copa-mercosul-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaSantaTerezaDoOesteDeJiuJitsu2025 from "./tournament/all-check-category-copa-santa-tereza-do-oeste-de-jiu-jitsu-2025";
import AllCheckCategoriesIiOpenNhamundaDeJiuJitsu2025 from "./tournament/all-check-category-ii-open-nhamunda-de-jiu-jitsu-2025";
import AllCheckCategoriesVOpenTerraSantaDeJiuJitsu2025 from "./tournament/all-check-category-v-open-terra-santa-de-jiu-jitsu-2025";
import AllCheckCategoriesIiiCopaBjjCascavelDeJiuJitsu2025 from "./tournament/all-check-category-iii-copa-bjj-cascavel-de-jiu-jitsu-2025";
import AllCheckCategoriesIiCopaThomasiDeJiuJitsu2025 from "./tournament/all-check-category-ii-copa-thomasi-de-jiu-jitsu-2025";
import AllCheckCategoriesOpenCandoiDeJiuJitsu2025 from "./tournament/all-check-category-open-candoi-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaMestreDoAcaiDeJiuJitsu2025 from "./tournament/all-check-category-copa-mestre-do-acai-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaFronteiraDeJiuJitsu2025 from "./tournament/all-check-category-copa-fronteira-de-jiu-jitsu-2025";
import AllCheckCategoriesOpenCascavelInternationalDeJiuJitsu2025 from "./tournament/all-check-category-open-cascavel-international-de-jiu-jitsu-2025";
import AllCheckCategoriesIiCopaAquilesDeJiuJitsu2025 from "./tournament/all-check-category-ii-copa-aquiles-de-jiu-jitsu-2025";
import AllCheckCategoriesIValenteKidsDeJiuJitsu2025 from "./tournament/all-check-category-i-valente-kids-de-jiu-jitsu-2025";
import AllCheckCategoriesICopaLeaoDeJudaDeJiuJitsu2025 from "./tournament/all-check-category-i-copa-leao-de-juda-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaLoboBravoCresolDeJiuJitsu2025 from "./tournament/all-check-category-copa-lobo-bravo-cresol-de-jiu-jitsu-2025";
import AllCheckCategoriesXxxiiiCopaOrleyLobatoDeJiuJitsu2025 from "./tournament/all-check-category-xxxiii-copa-orley-lobato-de-jiu-jitsu-2025";
import AllCheckCategoriesOpenFiveDeJiuJitsu2025 from "./tournament/all-check-category-open-five-de-jiu-jitsu-2025";
import AllCheckCategoriesViiiOpenAmazonasTopTeamDeJiuJitsu2025 from "./tournament/all-check-category-viii-open-amazonas-top-team-de-jiu-jitsu-2025";
import AllCheckCategoriesIxReiERainhaDaPraiaBeachWrestling2025 from "./tournament/all-check-category-ix-rei-e-rainha-da-praia-beach-wrestiling-2025";
import AllCheckCategoriesCopaCianorteDeJiuJitsu2025 from "./tournament/all-check-category-copa-cianorte-de-jiu-jitsu-2025";
import AllCheckCategoriesViiiLijjamCombatDeJiuJitsu2025 from "./tournament/all-check-category-viii-lijjam-combat-de-jiu-jitsu-2025";
import AllCheckCategoriesLijjamCombatIxCombatDeJiuJitsu2026 from "./tournament/all-check-category-lijjam-combat-ix-de-jiu-jitsu-2026";
import AllCheckCategoriesEstadualGfTeamAmazonasDeJiuJitsu2025 from "./tournament/all-check-category-estadual-gfteam-amazonas-de-jiu-jitsu-2025";
import AllCheckCategoriesICopaEuAmoParintinsDeJiuJitsu2025 from "./tournament/all-check-category-i-copa-eu-amo-parintins-de-jiu-jitsu-2025";
import AllCheckCategoriesFozOpenConfrontoInternacionalDeJiuJitsu2025 from "./tournament/all-check-category-foz-open-confronto-internacional-de-jiu-jitsu-2025";
import AllCheckCategoriesOpenChallengerDeJiuJitsu2025 from "./tournament/all-check-category-open-challenger-de-jiu-jitsu-2025";
import AllCheckCategoriesViiReiDaPraiaDeJiuJitsu2025 from "./tournament/all-check-category-vii-rei-da-praia-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaMestreDoAcaiKidsDeJiuJitsu2025 from "./tournament/all-check-category-copa-mestre-do-acai-kids-de-jiu-jitsu-2025";
import AllCheckCategoriesOpenParanavaiBrazilianDeJiuJitsu2025 from "./tournament/all-check-category-open-paranavai-brazilian-de-jiu-jitsu-2025";
import AllCheckCategoriesNoroesteOpenDeJiuJitsu2025 from "./tournament/all-check-category-noroeste-open-de-jiu-jitsu-2025";
import AllCheckCategoriesIvOpenParaguacuPaulistaDeJiuJitsu2025 from "./tournament/all-check-category-iv-open-paraguacu-paulista-de-jiu-jitsu-2025";
import AllCheckCategoriesIiiCopaChampiosKidsEBushidoDeJiuJitsu2025 from "./tournament/all-check-category-iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-2025";
import AllCheckCategoriesOpenLaranjeirasDoSulDeJiuJitsu2025 from "./tournament/all-check-category-open-laranjeiras-do-sul-de-jiu-jitsu-2025";
import AllCheckCategoriesToledoOpenBrazilianDeJiuJitsu2025 from "./tournament/all-check-category-toledo-open-brazilian-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaTomeyaSasaharaDeJiuJitsu2025 from "./tournament/all-check-category-copa-tomeya-sasahara-de-jiu-jitsu-2025";
import AllCheckCategoriesICopaFaixaSolidariaDeJiuJitsu2025 from "./tournament/all-check-category-i-copa-faixa-solidaria-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaOpenExtremeManausDeJiuJitsu2025 from "./tournament/all-check-category-copa-open-extreme-manaus-de-jiu-jitsu-2025";
import AllCheckCategoriesXiCopaLondrinaDeJiuJitsu2025 from "./tournament/all-check-category-xi-copa-londrina-de-jiu-jitsu-2025";
import AllCheckCategoriesCopaArapongasDeJiuJitsu2026 from "./tournament/all-check-category-copa-arapongas-de-jiu-jitsu-2026";
import AllCheckCategoriesXiXCopaParanaDeJiuJitsu2026 from "./tournament/all-check-category-xix-copa-parana-de-jiu-jitsu-2026";
import AllCheckCategoriesCircuitoInternacionalDeJiuJitsu2026 from "./tournament/all-check-category-circuito-internacional-de-jiu-jitsu-2026";
import AllCheckCategoriesCopaParintinenseDeJiuJitsu2026 from "./tournament/all-check-category-copa-parintinense-de-jiu-jitsu-2026";
import AllCheckCategoriesIiCopaMercosulDeJiuJitsu2026 from "./tournament/all-check-category-ii-copa-mercosul-de-jiu-jitsu-2026";
import AllCheckCategoriesStiOpenKidsDeJiuJitsu2026 from "./tournament/all-check-category-sti-open-kids-de-jiu-jitsu-2026";
import AllCheckCategoriesCampeonatoDeJiuJitsuGladiadoresAbleBjjJudo2026 from "./tournament/all-check-category-campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-2026";
import AllCheckCategoriesIGrandSlamEstadualDeJiuJitsuFeminino2026 from "./tournament/all-check-category-i-grand-slam-estadual-de-jiu-jitsu-feminino-2026";
import AllCheckCategoriesViiiCopaCampeoesDeJiuJitsu2026 from "./tournament/all-check-category-viii-copa-campeoes-de-jiu-jitsu-2026";
import AllCheckCategoriesSeletivaManausOlimpicaDeJiuJitsu2026 from "./tournament/all-check-category-seletiva-manaus-olimpica-de-jiu-jitsu-2026";
import AllCheckCategoriesCopaAmizadeDeJiuJitsu2026 from "./tournament/all-check-category-copa-amizade-de-jiu-jitsu-2026";
import AllCheckCategoriesIvCopaClbjjDeJiuJitsu2026 from "./tournament/all-check-category-iv-copa-clbjj-de-jiu-jitsu-2026";
import AllCheckCategoriesICopaBjjTalentDeJiuJitsu2026 from "./tournament/all-check-category-i-copa-bjj-talent-de-jiu-jitsu-2026";
import AllCheckCategoriesOpenFiveDeJiuJitsu2026 from "./tournament/all-check-category-open-five-de-jiu-jitsu-2026";
import AllCheckCategoriesCircuitoFajjeCoariDeJiuJitsuCoariAm from "./tournament/all-check-category-circuito-fajje-coari-de-jiu-jitsu-coari-am";
import AllCheckCategoriesICircuitoAmazonenseFajjoManausAm from "./tournament/all-check-category-i-circuito-amazonense-fajjo-manaus-am";
import AllCheckCategoriesOpenCambeDeJiuJitsu2026 from "./tournament/all-check-category-open-cambe-de-jiu-jitsu-2026";
import AllCheckCategoriesICampeonatoAmazonenseDeMmaAmador2026 from "./tournament/all-check-category-i-campeonato-amazonense-de-mma-amador-2026";
import AllCheckCategoriesDesafioZonaNorteDeJiuJitsuManausAm2026 from "./tournament/all-check-category-desafio-zona-norte-de-jiu-jitsu-manaus-am-2026";
import AllCheckCategoriesIiCopaBushidoDeJiuJitsu2026 from "./tournament/all-check-category-ii-copa-bushido-de-jiu-jitsu-2026";
import AllCheckCategoriesViOpenTerraSantaDeJiuJitsu2026 from "./tournament/all-check-category-vi-open-terra-santa-de-jiu-jitsu-2026";
import AllCheckCategoriesICampeonatoInternoCtTeamKombatDeJiuJitsu2026 from "./tournament/all-check-category-i-campeonato-interno-ct-team-kombat-de-jiu-jitsu-2026";
import AllCheckCategoriesIiOpenChallengerDeJiuJitsu2026 from "./tournament/all-check-category-ii-copa-challenger-de-jiu-jitsu-2026";
import AllCheckCategoriesXxxivCopaOrleyLobatoDeJiuJitsu2026 from "./tournament/all-check-category-xxxiv-copa-orley-lobato-de-jiu-jitsu-2026";

const AllCheckCategories = () => {
  const { slug } = useParams();

  switch (slug) {
    // case "seletiva-manaus-olimpica-2024-ginasio-ninimberg-guerra-sao-jorge-manaus-am":
    case "i-rei-e-rainha-da-praia-beach-boxing-manaus-amazonas-2023-manaus-amazonas":
      return <AllCheckCategoriesSeletivaManausOlimpica2024 />;
    case "viii-rei-e-rainha-da-praia-beach-wrestling-2024-nossa-praia-sports":
      return <AllCheckCategoriesCheckViiiReiERainhaDaPraiaBeachWrestiling2024 />;
      return <AllCheckCategoriesCopaAmizadeDeJiuJitsu2024 />;
    case "copa-mestre-acai-de-jiu-jitsu-2024-ginasio-arrudao-francisco-beltao-pr":
    case "xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-gi":
    case "xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-nogi":
      return <AllCheckCategoriesCopaMestreAcaiDeJiuJitsu2024 />;
    case "xxxii-copa-orley-lobato-de-jiu-jitsu-cel-nininberg-guerra-manaus-am":
    case "ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi":
    case "ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi":
    case "i-copa-thomasi-de-jiu-jitsu-parque-do-japao-maringa-pr":
    case "iv-opem-terra-santa-de-jiu-jistu-ginasio-braulio-nelson-da-conceicao-gi":
    case "iv-opem-terra-santa-de-jiu-jistu-ginasio-braulio-nelson-da-conceicao-nogi":
      return <AllCheckCategoriesXxxiiCopaOrleyLobatoDeJiuJitsu />;
    case "i-orixicombat-open-jiu-jitsu-ginasio-municipal-de-oriximina-pa":
      return <AllCheckCategoriesIOrixicombatOpenJiuJitsu />;
    case "copa-amizade-de-jiu-jitsu-2024-ginasio-de-esportes-amario-vieira-da-costa-umuarama-pr":
    case "copa-fronteira-de-jiu-jitsu-ginasio-de-esportes-amario-vieira-da-costa-umuarama-pr":
      return <AllCheckCategoriesJiuJitsuLaranjaEVerdeJuntos />;
    case "copa-lobo-bravo-cresol-de-jiu-jitsu-ginasio-assuncao-de-nossa-senhora-guarapuava-pr":
      return <AllCheckCategoriesCopaLoboBravoCresolDeJiuJitsu />;
    case "OLD-iv-opem-terra-santa-de-jiu-jistu-ginasio-braulio-nelson-da-conceicao-gi":
      return <AllCheckCategoriesIvOpenTerraSantaDeJiuJitsu />;
    case "vii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckCategoriesOpenAmazonasTopTeamDeJiuJitsu />;
    case "copa-cianorte-de-jiu-jitsu-cianorte-pr-gi":
      return <AllCheckCategoriesCopaCianorteDeJiuJitsu />;
    case "vi-rei-da-praia-de-jiu-jitsu-santarem-pa-nogi":
      return <AllCheckCategoriesViReiDaPraiaDeJiuJitsuNoGi />;
    case "ii-copa-champions-kids-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckCategoriesIiCopaChampionsKidsDeJiuJitsu />;
    case "iii-open-rocha-e-moraes-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckCategoriesIiiOpenRochaEMoraesDeJiuJitsu />;
    case "i-open-laranjeiras-do-sul-de-jiu-jitsu-laranjeiras-pr-gi":
      return <AllCheckCategoriesIOpenLaranjeirasDoSulDeJiuJitsu />;
    case "estadual-gf-team-amazonas-jiu-jitsu-manaus-am-gi":
    case "estadual-gf-team-amazonas-jiu-jitsu-manaus-am-nogi":
      return <AllCheckCategoriesEstadualGfTeamAmazonasDeJiuJitsu />;
    case "xxix-copa-luis-neto-jiu-jitsu-manaus-am-gi":
    case "xxix-copa-luis-neto-jiu-jitsu-manaus-am-nogi":
    case "copa-manacapuru-de-jiu-jitsu-mananacapuru-am-gi":
    case "copa-manacapuru-de-jiu-jitsu-mananacapuru-am-nogi":
      return <AllCheckCategoriesXxixCopaLuisNetoDeJiuJitsu />;
    case "etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu-oriximina-pa-gi":
    case "etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu-oriximina-pa-nogi":
      return <AllCheckCategoriesEtapaOriximinaXxxiiCopaOrleyLobatoDeJiuJitsu />;
    case "campeonato-parintinense-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi":
    case "campeonato-parintinense-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi":
    case "seletiva-manaus-olimpica-2024-ginasio-ninimberg-guerra-sao-jorge-manaus-am":
      return <AllCheckCategoriesCampeonatoParintinenseDeJiuJitsu />;
    case "xviii-copa-parana-de-jiu-jitsu-cascavel-pr-gi":
    case "xviii-copa-parana-de-jiu-jitsu-cascavel-pr-nogi":
      return <AllCheckCategoriesXviiiCopaParanaDeJiuJitsu />;
    case "copa-in-the-guard-de-jiu-jitsu-cascavel-pr-gi":
      return <AllCheckCategoriesCopaInTheGuardDeJiuJitsu />;
    case "copa-amizade-de-jiu-jitsu-2025-umuarama-pr-gi":
      return <AllCheckCategoriesCopaAmizadeDeJiuJitsu2025 />;
    case "vii-copa-campeoes-de-jiu-jitsu-maringa-pr-gi":
        return <AllCheckCategoriesViiCopaCampeoesDeJiuJitsu2025 />;
    case "copa-torneio-facil-de-jiu-jitsu-manaus-am-gi":
    case "copa-torneio-facil-de-jiu-jitsu-manaus-am-nogi":
        return <AllCheckCategoriesCopaTorneioFacilDeJiuJitsu />;
    case "copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-gi":
        return <AllCheckCategoriesCopaMercosulDeJiuJitsu2025 />;
    case "copa-santa-tereza-do-oeste-de-jiu-jitsu-santa-tereza-do-oeste-pr-gi":
        return <AllCheckCategoriesCopaSantaTerezaDoOesteDeJiuJitsu2025 />;
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-gi":
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-nogi":
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-gi-absoluto":
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-nogi-absoluto":
        return <AllCheckCategoriesIiOpenNhamundaDeJiuJitsu2025/>;
    case "v-open-terra-santa-de-jiu-jitsu-2025-terra-santa-pa-gi":
    case "v-open-terra-santa-de-jiu-jitsu-2025-terra-santa-pa-nogi":
        return <AllCheckCategoriesVOpenTerraSantaDeJiuJitsu2025/>;
    case "iii-copa-bjj-cascavel-de-jiu-jitsu-cascavel-pr-gi":
    case "iii-copa-bjj-cascavel-de-jiu-jitsu-cascavel-pr-nogi":
        return <AllCheckCategoriesIiiCopaBjjCascavelDeJiuJitsu2025/>;
    case "ii-copa-thomasi-de-jiu-jitsu-maringa-pr-gi":
        return <AllCheckCategoriesIiCopaThomasiDeJiuJitsu2025/>;
    case "open-candoi-de-jiu-jitsu-candoi-centro-sul-pr-gi":
        return <AllCheckCategoriesOpenCandoiDeJiuJitsu2025/>;
    case "copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-gi":
    case "copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-nogi":
        return <AllCheckCategoriesCopaMestreDoAcaiDeJiuJitsu2025/>;
    case "copa-fronteira-de-jiu-jitsu-2025-umuarama-pr-gi":
        return <AllCheckCategoriesCopaFronteiraDeJiuJitsu2025 />;
    case "open-cascavel-international-de-jiu-jitsu-cascavel-pr-gi":
    case "open-cascavel-international-de-jiu-jitsu-cascavel-pr-nogi":
        return <AllCheckCategoriesOpenCascavelInternationalDeJiuJitsu2025/>;
    case "ii-copa-aquiles-de-jiu-jitsu-foz-do-iguacu-pr-gi":
        return <AllCheckCategoriesIiCopaAquilesDeJiuJitsu2025 />;
    case "i-valente-kids-de-jiu-jitsu-nova-olimpia-pr-gi":
        return <AllCheckCategoriesIValenteKidsDeJiuJitsu2025 />;
    case "i-copa-leao-de-juda-de-jiu-jitsu-mandaguari-pr-gi":
        return <AllCheckCategoriesICopaLeaoDeJudaDeJiuJitsu2025 />;
    case "copa-lobo-bravo-cresol-de-jiu-jitsu-guarapuava-pr-gi":
        return <AllCheckCategoriesCopaLoboBravoCresolDeJiuJitsu2025 />;
    case "xxxiii-copa-orley-lobato-de-jiu-jitsu-manaus-am-gi":
    case "xxxiii-copa-orley-lobato-de-jiu-jitsu-manaus-am-absoluto":
        return <AllCheckCategoriesXxxiiiCopaOrleyLobatoDeJiuJitsu2025 />;
    case "open-five-de-jiu-jitsu-londrina-pr-gi":
    case "open-five-de-jiu-jitsu-londrina-pr-nogi":
        return <AllCheckCategoriesOpenFiveDeJiuJitsu2025 />;
    case "viii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-gi":
    case "viii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-nogi":
        return <AllCheckCategoriesViiiOpenAmazonasTopTeamDeJiuJitsu2025 />;
    case "ix-rei-e-rainha-da-praia-beach-wrestiling-2025-manaus-am":
        return <AllCheckCategoriesIxReiERainhaDaPraiaBeachWrestling2025 />;
    case "copa-cianorte-de-jiu-jitsu-2025-cianorte-pr-gi":
        return <AllCheckCategoriesCopaCianorteDeJiuJitsu2025 />;
    // case "viii-lijjam-combat-de-jiu-jitsu-manaus-am-gi":
    // case "viii-lijjam-combat-de-jiu-jitsu-manaus-am-nogi":
    //     return <AllCheckCategoriesViiiLijjamCombatDeJiuJitsu2025 />;
    case "lijjam-combat-ix-de-jiu-jitsu-manaus-am-gi":
    case "lijjam-combat-ix-de-jiu-jitsu-manaus-am-nogi":
    case "viii-lijjam-combat-de-jiu-jitsu-manaus-am-gi":
    case "viii-lijjam-combat-de-jiu-jitsu-manaus-am-nogi":
        return <AllCheckCategoriesLijjamCombatIxCombatDeJiuJitsu2026 />;
    case "estadual-gfteam-amazonas-de-jiu-jitsu-manaus-am-gi":
    case "estadual-gfteam-amazonas-de-jiu-jitsu-manaus-am-nogi":
        return <AllCheckCategoriesEstadualGfTeamAmazonasDeJiuJitsu2025 />;
    case "i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-gi":
    case "i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-absoluto":
        return <AllCheckCategoriesICopaEuAmoParintinsDeJiuJitsu2025 />;
    case "foz-open-confronto-internacional-de-jiu-jitsu-foz-do-iguacu-pr-gi":
        return <AllCheckCategoriesFozOpenConfrontoInternacionalDeJiuJitsu2025 />;
    case "open-challenger-de-jiu-jitsu-manaus-am-gi":
    case "open-challenger-de-jiu-jitsu-manaus-am-nogi":
        return <AllCheckCategoriesOpenChallengerDeJiuJitsu2025 />;
    case "vii-rei-da-praia-de-jiu-jitsu-santarem-pa-nogi":
        return <AllCheckCategoriesViiReiDaPraiaDeJiuJitsu2025 />;
    case "copa-mestre-do-acai-de-kids-jiu-jitsu-francisco-beltrao-pr-gi":
        return <AllCheckCategoriesCopaMestreDoAcaiKidsDeJiuJitsu2025 />;
    case "open-paranavai-brazilian-de-jiu-jitsu-paranavai-pr-gi":
    case "open-paranavai-brazilian-de-jiu-jitsu-paranavai-pr-nogi":
        return <AllCheckCategoriesOpenParanavaiBrazilianDeJiuJitsu2025 />;
    case "noroeste-open-de-jiu-jitsu-2025-umuarama-pr-gi":
    case "noroeste-open-de-jiu-jitsu-2025-umuarama-pr-nogi":
        return <AllCheckCategoriesNoroesteOpenDeJiuJitsu2025 />;
    case "iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-gi":
    case "iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-nogi":
        return <AllCheckCategoriesIvOpenParaguacuPaulistaDeJiuJitsu2025 />;
    case "iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-maringa-pr-gi":
        return <AllCheckCategoriesIiiCopaChampiosKidsEBushidoDeJiuJitsu2025 />;
    case "open-laranjeiras-do-sul-de-jiu-jitsu-laranjeiras-do-sul-pr-gi":
        return <AllCheckCategoriesOpenLaranjeirasDoSulDeJiuJitsu2025 />;
    case "toledo-open-brazilian-de-jiu-jitsu-toledo-pr-gi":
    case "toledo-open-brazilian-de-jiu-jitsu-toledo-pr-nogi":
       return <AllCheckCategoriesToledoOpenBrazilianDeJiuJitsu2025 />;
    case "copa-tomeya-sasahara-de-jiu-jitsu-umuarama-pr-gi":
       return <AllCheckCategoriesCopaTomeyaSasaharaDeJiuJitsu2025 />; 
    case "i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi":
       return <AllCheckCategoriesICopaFaixaSolidariaDeJiuJitsu2025 />;   
    case "copa-open-extreme-manaus-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckCategoriesCopaOpenExtremeManausDeJiuJitsu2025 />;  
    case "xi-copa-londrina-de-jiu-jitsu-londrina-pr-gi":
      return <AllCheckCategoriesXiCopaLondrinaDeJiuJitsu2025 />;
    case "copa-arapongas-de-jiu-jitsu-arapongas-pr-gi":
      return <AllCheckCategoriesCopaArapongasDeJiuJitsu2026 />;
    case "xix-copa-parana-de-jiu-jitsu-cascavel-pr-gi":
    case "xix-copa-parana-de-jiu-jitsu-cascavel-pr-nogi":
      return <AllCheckCategoriesXiXCopaParanaDeJiuJitsu2026 />;
    case "circuito-internacional-de-jiu-jitsu-cascavel-pr-gi":
    case "circuito-internacional-de-jiu-jitsu-cascavel-pr-nogi":
      return <AllCheckCategoriesCircuitoInternacionalDeJiuJitsu2026 />;
    case "copa-parintinense-de-jiu-jitsu-parintins-am-gi":
    case "copa-parintinense-de-jiu-jitsu-parintins-am-nogi":
      return <AllCheckCategoriesCopaParintinenseDeJiuJitsu2026 />;
    case "ii-copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-gi":
    case "ii-copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-nogi":
      return <AllCheckCategoriesIiCopaMercosulDeJiuJitsu2026 />;
    case "sti-open-kids-de-jiu-jitsu-santa-terezinha-de-itaipu-pr-gi":
    case "sti-open-kids-de-jiu-jitsu-santa-terezinha-de-itaipu-pr-nogi":
      return <AllCheckCategoriesStiOpenKidsDeJiuJitsu2026 />;
    case "campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-manaus-am-gi":
      return <AllCheckCategoriesCampeonatoDeJiuJitsuGladiadoresAbleBjjJudo2026 />;                               
    case "i-grand-slam-estadual-de-jiu-jitsu-santarem-pa-gi":
      return <AllCheckCategoriesIGrandSlamEstadualDeJiuJitsuFeminino2026 />; 
    case "viii-copa-campeoes-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckCategoriesViiiCopaCampeoesDeJiuJitsu2026 />; 
    case "seletiva-manaus-olimpica-2026-ginasio-ninimberg-guerra-sao-jorge-manaus-am":
      return <AllCheckCategoriesSeletivaManausOlimpicaDeJiuJitsu2026 />; 
    case "copa-amizade-de-jiu-jitsu-2026-umuarama-pr-gi":
      return <AllCheckCategoriesCopaAmizadeDeJiuJitsu2026 />;
    case "iv-copa-clbjj-de-jiu-jitsu-manaus-am-gi":
    case "iv-copa-clbjj-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckCategoriesIvCopaClbjjDeJiuJitsu2026 />;
    case "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-gi":
    case "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckCategoriesICopaBjjTalentDeJiuJitsu2026 />;
    case "open-five-de-jiu-jitsu-curiuva-pr-gi":
      return <AllCheckCategoriesOpenFiveDeJiuJitsu2026 />;
    case "circuito-fajje-coari-de-jiu-jitsu-coari-am-gi":
    case "circuito-fajje-coari-de-jiu-jitsu-coari-am-nogi":
      return <AllCheckCategoriesCircuitoFajjeCoariDeJiuJitsuCoariAm />;
    case "i-circuito-amazonense-fajjo-manaus-am-gi":
    case "i-circuito-amazonense-fajjo-manaus-am-nogi":
      return <AllCheckCategoriesICircuitoAmazonenseFajjoManausAm />;
    case "open-cambe-de-jiu-jitsu-cambe-pr-gi":
      return <AllCheckCategoriesOpenCambeDeJiuJitsu2026 />;
    case "i-campeonato-amazonense-de-mma-amador-manaus-am":
      return <AllCheckCategoriesICampeonatoAmazonenseDeMmaAmador2026 />;
    case "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-gi":
    case "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-nogi":
      return <AllCheckCategoriesDesafioZonaNorteDeJiuJitsuManausAm2026 />;
    case "ii-copa-bushido-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckCategoriesIiCopaBushidoDeJiuJitsu2026 />;
    case "vi-open-terra-santa-de-jiu-jitsu-terra-santa-pa-gi":
    case "vi-open-terra-santa-de-jiu-jitsu-terra-santa-pa-nogi":
      return <AllCheckCategoriesViOpenTerraSantaDeJiuJitsu2026 />;
    case "i-campeonato-interno-ct-kombat-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <AllCheckCategoriesICampeonatoInternoCtTeamKombatDeJiuJitsu2026 />;
    case "ii-open-challenger-de-jiu-jitsu-manaus-am-gi":
    case "ii-open-challenger-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckCategoriesIiOpenChallengerDeJiuJitsu2026 />;
    case "xxxiv-copa-orley-lobato-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckCategoriesXxxivCopaOrleyLobatoDeJiuJitsu2026 />;


    default:
      return <h1>Checagem para esse Torneio não encontrado!</h1>;
  }
};

export default AllCheckCategories;
